export default "/images/moon.svg?a82cae44d086a825a6fa3dfb65dce3ba";